import 'react-multi-carousel/lib/styles.css';

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Carousel from 'react-multi-carousel';
import { useNavigate } from 'react-router-dom';

import useWindowSize from '../../hooks/useWindowSize';
// import { blogsData } from './InterfacesBlogs';

export default function CarouselBlog({ blogsData ,pageType}) {
    CarouselBlog.propTypes = {
        blogsData: PropTypes.any,
        pageType: PropTypes.any,
    };
    const navigate=useNavigate();
    const [groupedItems,setGroupedItems]=useState();
    const { i18n } = useTranslation();

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1, // Adjust the number of items shown per slide
            partialVisibilityGutter: 40 // Add gutter for partial visibility
        },
        desktop: {
            breakpoint: { max: 1300, min: 700 },
            items: 1,
            partialVisibilityGutter: 40
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            partialVisibilityGutter: 40
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 40
        }
    };

    const {device}=useWindowSize();
    useEffect(()=>{
        if(device=='desktop'){
            const gItems = [];
            for (let i = 0; i < blogsData.length; i += 6) {
                gItems.push(blogsData.slice(i, i + 6));
            }
            setGroupedItems(gItems);
        }
        else{
            const gItems = [];
            for (let i = 0; i < blogsData.length; i += 2) {
                gItems.push(blogsData.slice(i, i + 2));
            }
            setGroupedItems(gItems);
        }

    },[blogsData,device]);

    useEffect(()=>{
        if(groupedItems)
            console.log('groupedItems',groupedItems);
    },[groupedItems]);

    function truncateText(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        }

        const truncatedText = text.slice(0, maxLength);
        const lastSpaceIndex = truncatedText.lastIndexOf(' ');

        if (lastSpaceIndex > 0) {
            return truncatedText.slice(0, lastSpaceIndex);
        }

        return truncatedText;
    }

    return (
        <div
            style={{
                fontFamily: 'sans-serif',
                textAlign: 'center',
                display:'flex',
                flexDirection:'column',
                gap:'64px',
                minWidth:device=='desktop'?'900px': '300px',
                maxWidth:'1024px',
                width:'90%',
            }}
        >
            <h3
                style={{
                    //styleName: Headline/H3;
                    fontFamily: 'Lato',
                    fontSize: '48px',
                    fontWeight: '700',
                    lineHeight: '56px',
                    letterSpacing: '-0.75px',
                    textAlign: 'left',
                    color:'#272D3C',
                }}
            >{i18n.t('Tous les articles')}</h3>

            <div style={{ position: 'relative', width:'100%' }}>
                <Carousel responsive={responsive}>
                    {Array?.isArray(groupedItems) && groupedItems.map((group, groupIndex) => (
                        <div
                            key={groupIndex}
                            style={{
                                display: 'grid',
                                gridTemplateColumns:device=='desktop'?'repeat(3,minmax(0,1fr)':'repeat(2,minmax(0,1fr)',
                                columnGap:'20px',}}
                        >
                            {group.map((item, index) => (
                                <div
                                    key={index}
                                    style={{ display:'grid',gridTemplateColumns:device=='desktop'?'auto auto':'auto',gap:'12px',textAlign: 'left',cursor:'pointer'}}
                                    onClick={()=>{
                                        if(pageType=='sourcing')
                                            navigate(`/blog/${index+1}`);
                                        else
                                            navigate(`/Consultingblogs/${index+1}`);

                                    }}
                                >
                                    <LazyLoadImage
                                        src={item.blog.image}
                                        width='139px'
                                        height='139px'
                                        style={{borderRadius:'8px'}}
                                    />
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                        <p
                                            className='blogFrame6'
                                        >{item.blog.date}</p>
                                        <h6
                                            style={{
                                                fontFamily: 'Lato',
                                                fontSize: '17px',  //22px
                                                fontWeight: '600',
                                                lineHeight: '29px', //32px
                                                letterSpacing: '-0.15000000596046448px',
                                                textAlign: 'left',
                                                margin:'0px',
                                                height: '114px',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {item.blog.title.length>80 ? truncateText(item.blog.title,75): item.blog.title}{item.blog.title.length>75 ? '...' : ' '}
                                        </h6>
                                        <p
                                            style={{
                                                fontFamily: 'Lato',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                lineHeight: '16px',
                                                letterSpacing: '0.004em',
                                                textAlign: 'left',
                                                color:'#827F7F',
                                            }}
                                        > {i18n.t('Par')} <span style={{color:'#475063'}}> {i18n.t('l\'équipe HTH')}</span></p>
                                    </div>

                                </div>
                            ))}
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>
    );
}
